// import {gsap} from 'gsap';

import { deepMerge } from 'js/utils/Utils'

const defaults = {
  $names: {
    target: '[data-js-hover]',
  },
  dataNames: {
    hoverNumber: 'hoverNum',
  },
}

export default class BaseJsHover {
  constructor(options = {}) {
    this.$contentRoot = document
    this.$targets = []
    this.targetInfoList = []

    this.event = {
      mouseEnter: this._onMouseEnter.bind(this),
      mouseLeave: this._onMouseLeave.bind(this),
    }

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()

    this.$targets.forEach(($target, i) => {
      this._setTargetInfoList($target, i)
      this._addEventListeners($target)
    })
  }

  destroy() {
    this.$targets.forEach(($target, i) => {
      if ($target) {
        this._removeEventListeners($target)
      }
    })
  }

  _set$() {
    this.$targets = this.$contentRoot.querySelectorAll(this.$names.target)
  }

  _setTargetInfoList($target, i) {
    $target.dataset[this.dataNames.hoverNumber] = i

    this.targetInfoList[i] = {
      isHovering: false,
      isAnimating: false,
    }
  }

  _addEventListeners($target) {
    $target.addEventListener('mouseenter', this.event.mouseEnter, false)
    $target.addEventListener('mouseleave', this.event.mouseLeave, false)
  }

  _removeEventListeners($target) {
    $target.removeEventListener('mouseenter', this.event.mouseEnter)
    $target.removeEventListener('mouseleave', this.event.mouseLeave)
  }

  _onMouseEnter(e) {
    const $target = e.currentTarget
    const num = Number($target.dataset[this.dataNames.hoverNumber])
    const infoListItem = this.targetInfoList[num]

    infoListItem.isHovering = true

    if (!infoListItem.isAnimating) {
      this._startMouseEnter($target, num, infoListItem)
    }
  }

  _onMouseLeave(e) {
    let $target = e.currentTarget
    const num = Number($target.dataset[this.dataNames.hoverNumber])
    const infoListItem = this.targetInfoList[num]

    infoListItem.isHovering = false

    if (infoListItem.hoverParent) {
      $target = infoListItem.hoverParent
    }

    if (!infoListItem.isAnimating) {
      this._startMouseLeave($target, num, infoListItem)
    }
  }

  _startMouseEnter($this, num, infoListItem) {
    infoListItem.isAnimating = true

    this._enterAnimation($this, num).then(() => {
      this._completeMouseEnter($this, num, infoListItem)
    })
  }

  _startMouseLeave($this, num, infoListItem) {
    infoListItem.isAnimating = true

    this._leaveAnimation($this, num).then(() => {
      this._completeMouseLeave($this, num, infoListItem)
    })
  }

  _completeMouseEnter($this, num, infoListItem) {
    infoListItem.isAnimating = false

    if (!infoListItem.isHovering) {
      this._startMouseLeave($this, num, infoListItem)
    }
  }

  _completeMouseLeave($this, num, infoListItem) {
    infoListItem.isAnimating = false
    requestAnimationFrame(() => {
      if (infoListItem.isHovering) {
        this._startMouseEnter($this, num, infoListItem)
      }
    })
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      resolve()
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      resolve()
    })
  }
}